var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    transform: "translate(1703 22505)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1032",
    "data-name": "Rectangle 1032",
    width: 18,
    height: 1.143,
    transform: "translate(-1703 -22496.725)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1033",
    "data-name": "Rectangle 1033",
    width: 18,
    height: 1.143,
    transform: "translate(-1693.275 -22505) rotate(90)",
    fill: "#bfbfbf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1ae68bb234b2afecc62c34f90b26b7e5.svg";
export { ForwardRef as ReactComponent };